import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';

const JIRA_DEFER_VIEW_CHAT_OPEN_UNTIL_SEEDED_EXPERIMENT =
	'jira_rovo_defer_view_chat_open_until_seeded';

// Jira records this experiment's exposure when the CTA is invoked. Rovo only consumes that event.
export const isJiraDeferredSeededChatOpenEnabled = (): boolean =>
	UNSAFE_expValNoExposure(JIRA_DEFER_VIEW_CHAT_OPEN_UNTIL_SEEDED_EXPERIMENT, 'isEnabled', false);
